module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "Arial"
    }
  }, [_c('strong', [_vm._v("List of Figures")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin": "auto",
      "font-weight": "bold"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    staticStyle: {
      "border": "0px solid white",
      "padding-top": "5px"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('strong', [_vm._v("Figure 1:"), _c('br')])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "left"
    }
  }, [_c('strong', [_vm._v("Difference Between Phonology and Phonetics\n(Articulation)")])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('strong', [_vm._v("Figure 2:")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Components of Spoken Language")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('strong', [_vm._v("Figure 3:")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Levels of Spoken Language ")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    staticStyle: {
      "border": "0px solid white",
      "padding-top": "5px"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('strong', [_vm._v("Figure 4:"), _c('br'), _c('br')])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Simple Classification System for ‘Underlying\nLevels’ of Difficulty in Speech Sound"), _c('br'), _vm._v("\nDisorders ")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('strong', [_vm._v("Figure 5:")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Speech Sound Disorder Tree")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('strong', [_vm._v("Figure 6:")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Tongue Thrust")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('strong', [_vm._v("Figure 7:"), _c('br')])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px solid white"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("A Diagnostic Sheet for Diagnosis of Speech Sound\nDisorder")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 75
// module chunks = 0